import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import ThaiBahtText from "thai-baht-text";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      amount: "0.00",
      amount_deposit: "0.00",
      total_pay: "0.00",
      transaction_list: [],
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("uid")) {
      await this.Get(params("uid"));
    }
    window.print();
  }
  Get = async (id) => {
    loading(true);
    let result = await GET("admin/billing-notes/list", { uid: id });
    let item = result.data;
    // if (item.status === "ยกเลิก") {
    //   window.location.href = "/invoice/billings";
    // }
    this.setState({
      document_no: item.document_no,
      created_at: item.created_at,
      customer_name: item.customer?.full_name,
      customer_phone: item.customer?.phone,
      transaction_list: item.invoice || [],
      amount: item.amount,
      amount_deposit: item.amount_deposit,
      total_pay: item.total_pay,
    });

    loading(false);
  };
  render() {
    const {
      document_no,
      created_at,
      customer_name,
      customer_phone,
      transaction_list,
      amount,
      amount_deposit,
      total_pay,
    } = this.state;
    return (
      <div
        className="mx-auto bg-white p-5 pdf"
        style={{ width: 1116, height: 1579 }}
      >
        <div className="d-flex justify-content-between">
          <div>
            <h1 className="fw-bold mb-3">
              ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่
            </h1>
            <h4 className="fw-bold mb-3">
              61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่
              จ.เชียงใหม่
            </h4>
            <h5 className="fw-bold mb-3">
              โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060
            </h5>
          </div>
          <div>
            <div className="border-1 border-secondary p-4 mb-4">
              <h5 className="fw-bold mb-0">ใบวางบิล</h5>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <h5 className="fw-bold mb-3">เลขที่ : {document_no}</h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">
              วันที่ : {format_date(created_at, "dd MMMM yyyy", "th")}
            </h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">ชื่อลูกค้า : {customer_name}</h5>
          </div>
          <div className="col-6">
            <h5 className="fw-bold mb-3">เบอร์โทร : {customer_phone}</h5>
          </div>
        </div>
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="fw-bold border-0">
              <td className="text-center border-1">เลขที่ใบส่งสินค้า</td>
              <td className="text-center border-1 wpx-130">
                วันที่ใบส่งสินค้า
              </td>
              <td className="text-center border-1 wpx-130">ประเภทเอกสาร</td>
              <td className="text-center border-1 wpx-130">วันครบกำหนด</td>
              <td className="text-center border-1 wpx-230">จำนวนเงิน</td>
              <td className="text-center border-1 wpx-230">จำนวนเงินวางบิล</td>
            </tr>
          </thead>
          <tbody>
            {transaction_list.map((item, index) => (
              <>
                <tr className="border-0">
                  <td className="text-start" style={{ border: "0px 1px" }}>
                    {item.document_no}
                  </td>
                  <td className="text-center" style={{ border: "0px 1px" }}>
                    {format_date(item.sale?.created_at, "dd/mm/yyyy", "th")}
                  </td>
                  <td className="text-start" style={{ border: "0px 1px" }}>
                    {item.sale?.payment_type}
                  </td>
                  <td className="text-center" style={{ border: "0px 1px" }}>
                    {format_date(item.sale?.due_date, "dd/mm/yyyy", "th")}
                  </td>
                  <td className="text-end" style={{ border: "0px 1px" }}>
                    {toFixed(
                      Number(item.sale?.amount) * (item.sale?.is_vat ? 1.07 : 1)
                    )}
                  </td>
                  <td className="text-end" style={{ border: "0px 1px" }}>
                   {toFixed(
                      Number(item.sale?.amount) * (item.sale?.is_vat ? 1.07 : 1)
                    )}
                  </td>
                </tr>
                {item.credit_note.map((credit, credit_index) => (
                  <tr className="border-0">
                    <td className="text-start">{credit.document_no}</td>
                    <td className="text-center">
                      {format_date(credit.created_at, "dd/mm/yyyy", "th")}
                    </td>
                    <td className="text-start">ลดหนี้</td>
                    <td className="text-center">
                      {format_date(credit.due_date, "dd/mm/yyyy", "th")}
                    </td>
                    <td className="text-end">-{toFixed(credit?.amount * (item.sale?.is_vat ? 1.07 : 1))}</td>
                    <td className="text-end">-{toFixed(credit?.amount * (item.sale?.is_vat ? 1.07 : 1))}</td>
                  </tr>
                ))}
                {/* <tr className="border-0"><td style={{borderBottom:"1px solid #000",height:1,padding:0}} colSpan={5}></td></tr> */}
              </>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-0">
              <td className="text-start border-1" colSpan={5}>ยอดเงินที่ชำระแล้ว</td>
              <td className="text-end border-1">
                {(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    _total += Number(item.sale?.total_pay) ;
                  }
                  return toFixed(_total);
                })()}
              </td>
            </tr>
            <tr className="border-0">
              <td className="text-start border-1" colSpan={5}>
                ยอดเงินค้างชำระ
                ({(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    let _total_cre = 0;
                    for(let credit of item.credit_note){
                      _total_cre +=  credit?.amount * (item.sale?.is_vat ? 1.07 : 1)
                    }
                    _total +=( Number(item.sale?.amount) * (item.sale?.is_vat ? 1.07 : 1))- _total_cre - Number(item.sale?.total_pay) ;
                  }
                  if (_total < 0) _total = 0;
                  return ThaiBahtText(Number(_total || 0)) || "ศูนย์บาทถ้วน";
                })()})
              </td>
              <td className="text-end border-1">
                {(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    let _total_cre = 0;
                    for(let credit of item.credit_note){
                      _total_cre +=  credit?.amount * (item.sale?.is_vat ? 1.07 : 1)
                    }
                    _total +=( Number(item.sale?.amount) * (item.sale?.is_vat ? 1.07 : 1))- _total_cre - Number(item.sale?.total_pay) ;
                  }
                  if (_total < 0) _total = 0;
                  return toFixed(Number(_total));
                })()}
              </td>
            </tr>
          </tfoot>
        </table>
        <div className="d-flex justify-content-around pt-5">
          <div>
            <h4 className="fw-bold mb-4">บริษัท</h4>
            <h5 className="mb-4">
              ผู้วางบิล................................................................................................
            </h5>
            <h5 className="mb-4">
              ว/ด/ป....................................................................................................
            </h5>
          </div>
          <div>
            <h4 className="fw-bold mb-4">ลูกค้า</h4>
            <h5 className="mb-4">
              ผู้รับวางบิล............................................................................................
            </h5>
            <h5 className="mb-4">
              ว/ด/ป....................................................................................................
            </h5>
          </div>
        </div>
      </div>
    );
  }
}
